import { NetlogHttpClient } from 'lib/http';
import { FileAttachment } from 'models';
import { AttachmentHandler, FileId } from './attachment-handler';
import { MooringAttachmentType } from 'models/mooring';

export type MooringDocumentsHandlerArgs = {
  mooringId?: number;
  attachmentType: MooringAttachmentType;
};

export class MooringDocumentsHandler implements AttachmentHandler {
  private _mooringId?: number;
  private _attachmentType: MooringAttachmentType;

  constructor(
    private client: NetlogHttpClient,
    args: MooringDocumentsHandlerArgs
  ) {
    this._mooringId = args.mooringId;
    this._attachmentType = args.attachmentType;
  }

  set mooringId(id: number) {
    this.mooringId = id;
  }

  get baseUrl() {
    return `api/moorings/${this._mooringId}/attachments`;
  }

  upload(file: File) {
    const form = this.client.fileFormdata(file);
    return this.client.uploadFile(form, this.baseUrl + `/${this._attachmentType}`);
  }

  delete(storageFileId: FileId) {
    return this.client.delete({
      url: `${this.baseUrl}/${storageFileId}`,
    });
  }

  download(storageFileId: FileId) {
    return this.client.downloadBlob(`api/system-storage/${storageFileId}`);
  }

  async metadata() {
    const response = await this.client.get<FileAttachment[]>(
      {
        url: `api/moorings/${this._mooringId}/attachments/${this._attachmentType}`,
        model: FileAttachment,
      },
      { cache: false }
    );
    
    return response.data;
  }
}
